import { createFileRoute } from '@tanstack/react-router';
import {
  campaignsList,
  markupByCampaign,
  markupByChannel,
  markupByProduction,
  markupSummary,
  productionsList,
  reportingQuery,
} from '@/api/resources';
import { warm, warmBackground } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { MarkupReports } from '@/screens/markup';
import {
  markupReportRequest,
  operationalFreshnessRequest,
  parseMarkupReportSearch,
  serializeOperationalReportSearch,
  updateMarkupReportSearch,
} from '@/lib/operational-report-search';
import type { MarkupReportSearchPatch } from '@/lib/operational-report-search';

export const Route = createFileRoute('/reports/markup')({
  beforeLoad: requireCapability('reports_view'),
  validateSearch: parseMarkupReportSearch,
  loaderDeps: ({ search }) => search,
  // Search-driven route: no skeleton for an in-screen navigation (router.ts).
  pendingMs: Infinity,
  loader: ({ context, deps }) => {
    const request = markupReportRequest(deps);
    warmBackground(context.queryClient, campaignsList({}), productionsList({}));
    return warm(
      context.queryClient,
      markupSummary(request),
      markupByCampaign(request),
      markupByChannel(request),
      markupByProduction(request),
      reportingQuery(operationalFreshnessRequest(deps)),
    );
  },
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MarkupReports
      search={search}
      onSearchChange={(
        patch: MarkupReportSearchPatch,
        options?: { replace?: boolean },
      ) => {
        void navigate({
          search: (current) => serializeOperationalReportSearch(
            updateMarkupReportSearch(current, patch),
          ),
          replace: options?.replace,
        });
      }}
    />
  );
}
